

import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const APPLY_LEAVE_REQUEST = "APPLY_LEAVE_REQUEST";
export const APPLY_LEAVE_SUCCESS = "APPLY_LEAVE_SUCCESS";
export const APPLY_LEAVE_FAILURE = "APPLY_LEAVE_FAILURE";

// Action Creators
export const applyLeaveRequest = () => ({ type: APPLY_LEAVE_REQUEST });
export const applyLeaveSuccess = (data) => ({
  type: APPLY_LEAVE_SUCCESS,
  payload: data,
});
export const applyLeaveFailure = (error) => ({
  type: APPLY_LEAVE_FAILURE,
  payload: error,
});

// Thunk - Apply Leave
export const applyLeave = ({
  start_date,
  end_date,
  leave_gov_type,
  reason,
  photo, // File object
  status,
  user_id,
}) => {
  return async (dispatch) => {
    dispatch(applyLeaveRequest());

    const token = localStorage.getItem("token");

    const formData = new FormData();
    formData.append("start_date", start_date);
    formData.append("end_date", end_date);
    formData.append("leave_gov_type", leave_gov_type);
    formData.append("reason", reason);
    if (photo) formData.append("photo", photo);
    formData.append("status", status);
    formData.append("user_id", user_id);

    try {
      const res = await axios.post(
        `${BASE_URL}/v1/api/admin/apply_leave`,
        formData,
        {
          headers: {
            authorization: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      dispatch(applyLeaveSuccess(res.data));
      toast.success(res.data?.meta?.message || "Leave applied successfully");
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(applyLeaveFailure(errorMsg));
      toast.error(errorMsg);
    }
  };
};
